<template>
    <b-container>
        <b-row align-h="center">
            <b-col sm="8" md="6">
                <b-card no-header class="lead header-text">
                        <b-alert show variant="danger">
                            <b-media no-body>
                                <b-media-aside vertical-align="center">
                                    <icon name="times-circle" scale="3"></icon>
                                </b-media-aside>
                                <b-media-body class="ml-4">
                                    <h4 class="m-0 mb-2">{{ $t('general.errorPage.title') }}</h4>
                                    <h6 class="m-0">{{ errorMessage }}</h6>
                                </b-media-body>
                            </b-media>
                        </b-alert>
                        <hr>
                        <b-row>
                            <b-col >
                                <b-btn type="button" block
                                       variant="primary" 
                                       :to="{name: 'dashboard'}" exact>
                                       {{ $t('general.errorPage.homeBtn') }}
                                </b-btn>
                            </b-col>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import i18n from '@/i18n.bootstrap';

export default {
    name: 'error-page',

    props: {
        errorMessage: {
            type: String,
            default: function() {
                return i18n.t('general.errorPage.body');
            }
        }
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>
